const styleVariables = {
    primaryColor: '#db3c8c',
    secondaryColor: '#af3070',
    offWhite: '#f4f4f4',
    darkColor: '#404040',
};

export default styleVariables;